// extracted by mini-css-extract-plugin
export default {"filter-box-tag__draggable":"filter-box-tag__draggable--NNmYS","filterBoxTagDraggable":"filter-box-tag__draggable--NNmYS"};